import React, { FC } from 'react';

import { Uuid }                                                                                  from "@src/types";
import { ENTITY_ICONS }                                                                          from "@src/constants/ProductEnums";
import { ProjectActivityBulkUpdateShellFormContainerProps, ProjectActivityBulkUpdateShellProps } from "@src/views/pages/projects/activities/bulk/ProjectActivityBulkUpdateShell";
import { ProjectActivityBulkUpdateMultiDialogProps }                                             from "@src/views/pages/projects/operations/ProjectActivityBulkUpdateMultiDialog";
import { ProjectActivityBulkUpdateCostAttribute }                                                from "@src/views/pages/projects/activities/bulk/slices/ProjectActivityBulkUpdateCostAttribute";


type FormTypeAttributes = {
    costType: Uuid | null,
    ongoingCostOverride: number | null
}

interface ProjectActivityBulkUpdateOngoingCostProps extends Pick<ProjectActivityBulkUpdateShellProps<FormTypeAttributes>, 'supportModals' | 'supportToasts'>,
    Pick<ProjectActivityBulkUpdateMultiDialogProps, 'projectId' | 'projectVersionId' | 'projectActivityIds'> {
    formContainer: FC<ProjectActivityBulkUpdateShellFormContainerProps>
}

const ProjectActivityBulkUpdateOngoingCostDefaultProps = {
    supportModals: false,
    supportToasts: true,
} satisfies Partial<ProjectActivityBulkUpdateOngoingCostProps>

function ProjectActivityBulkUpdateOngoingCost( _props: ProjectActivityBulkUpdateOngoingCostProps ){

    const props = { ...ProjectActivityBulkUpdateOngoingCostDefaultProps, ..._props };

    return (

        <ProjectActivityBulkUpdateCostAttribute
            { ...props }
            attributeName={ 'ongoingCostOverride' }
            icon={ ENTITY_ICONS.BUDGET.ONGOING_COSTS }
            title={ 'Update Ongoing Cost' }
            description={ `Define a custom ongoing cost for multiple activities. Activities with professional fees assigned will have their costs overwritten to the single cost below.` }
            fieldLabel={ 'Ongoing Cost' }
            fieldDescription={ 'The ongoing cost assigned to each of the selected activities.' }/>

    );
}

export {
    ProjectActivityBulkUpdateOngoingCost,
    ProjectActivityBulkUpdateOngoingCostDefaultProps,
    type ProjectActivityBulkUpdateOngoingCostProps,
};
